const TOGGLE_ALERTS_MENU = 'ALERTS_MENU/TOGGLE_ALERTS_MENU';

export { TOGGLE_ALERTS_MENU };
